import { o_global } from "@gr-common/head/namespaces";
import { deprecated } from "@gr-common/head/logger";

o_global.onloadHandler ||= (cb) => {
  deprecated("o_global.onloadHandler");
  return o_global.eventLoader.onLoad(100, cb);
};
